import { getEnv } from './getEnv';

export const Locale = {
  De: 'de',
  At: 'at',
  Fr: 'fr',
  McInvest: 'mcinvest',
} as const;
export type LocaleValue = (typeof Locale)[keyof typeof Locale];

type Domain = {
  domain: string;
  locale: LocaleValue;
  http?: boolean;
};

export const getDomains = (): Domain[] => {
  const env = getEnv();
  const isLocalWithDomains = !!process.env.ENABLE_LOCAL_DOMAINS;
  const branchSlug = process.env.CI_COMMIT_REF_SLUG;

  switch (env) {
    case 'production':
      return [
        {
          domain: 'www.mcmakler.de',
          locale: Locale.De,
        },
        {
          domain: 'www.mcmakler.fr',
          locale: Locale.Fr,
        },
        {
          domain: 'www.mcmakler.at',
          locale: Locale.At,
        },
        {
          domain: 'www.mcmakler-investment.de',
          locale: Locale.McInvest,
        },
      ];

    case 'staging':
    case 'develop':
      return [
        {
          domain: `web-v3-de-${branchSlug}.mcmakler.com`,
          locale: Locale.De,
        },
        {
          domain: `web-v3-fr-${branchSlug}.mcmakler.com`,
          locale: Locale.Fr,
        },
        {
          domain: `web-v3-at-${branchSlug}.mcmakler.com`,
          locale: Locale.At,
        },
        {
          domain: `mcinvest-${branchSlug}.mcmakler.com`,
          locale: Locale.McInvest,
        },
      ];

    case 'local':
    default:
      return isLocalWithDomains
        ? [
            {
              domain: 'de.mcmakler.local',
              locale: Locale.De,
              http: true,
            },
            {
              domain: 'fr.mcmakler.local',
              locale: Locale.Fr,
              http: true,
            },
            {
              domain: 'at.mcmakler.local',
              locale: Locale.At,
              http: true,
            },
            {
              domain: 'mcinvest.mcmakler.local',
              locale: Locale.McInvest,
              http: true,
            },
          ]
        : [];
  }
};
